import { render } from "./BackButton.vue?vue&type=template&id=689bae28&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=689bae28&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689bae28"]])

export default __exports__